"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnrecognizedUrl = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const catalog_messages_1 = require("@tableau/catalog-messages");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const rootStyle = Object.assign(Object.assign({}, data_catalog_shared_1.vizPortalFontStyle), { flex: 1, position: 'relative', top: '15%', display: 'flex', flexDirection: 'column', alignItems: 'center' });
const rootClass = (0, vizportalclient_common_components_1.cssClass)('UnrecognizedUrlRoot', rootStyle);
function UnrecognizedUrl(props) {
    return (react_1.default.createElement("div", { className: rootClass },
        react_1.default.createElement("div", null, catalog_messages_1.Messages.UnrecognizedUrl()),
        react_1.default.createElement(react_router_dom_1.Link, { to: props.backToButtonUrl }, props.backToButtonLabel)));
}
exports.UnrecognizedUrl = UnrecognizedUrl;
//# sourceMappingURL=UnrecognizedUrl.js.map